import { axios } from '@Root/API'

export const getNationality = () => {
	return axios.get(`data-nationality-type`)
}
